function initializeObserver() {
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) {
                entry.target.classList.add(entry.target.dataset.animate);
                entry.target.classList.remove("not-in-view");
            } else entry.target.classList.add("not-in-view");
        });
    }, {
        root: null,
        rootMargin: "0px",
        threshold: [
            0.3,
            1
        ]
    });
    const tags = document.querySelectorAll("[data-animate]");
    tags.forEach((tag)=>{
        observer.observe(tag);
    });
}
initializeObserver();

//# sourceMappingURL=menu.fdd6e0ae.js.map
